import { render } from "./EmergencyAnswerAttachmentOffcanvas.vue?vue&type=template&id=3c487fc9&scoped=true&ts=true"
import script from "./EmergencyAnswerAttachmentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./EmergencyAnswerAttachmentOffcanvas.ts?vue&type=script&lang=ts"

import "./EmergencyAnswerAttachmentOffcanvas.scss?vue&type=style&index=0&id=3c487fc9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c487fc9"]])

export default __exports__